import axios from './configAxios.js';

export const getUsersApi = async (url) => {
    return await axios.get(`${url}`);
};